import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPauseCircle } from '@fortawesome/free-regular-svg-icons';
import exact from 'prop-types-exact';
import Placeholder from '../../../common/placeholder/Placeholder';

const TopSongs = ({ artistSlug, listTopSongs, isFetching, isPlayTopSong, pauseTopSong, playTopSong, fetchArtistTopSongsIfNeeded }) => {
    const [hoverOnSong, setHoverOnSong] = useState(false);

    function _handlingPause() {
        pauseTopSong();
    }

    function _handlingPlay(topSongData) {
        playTopSong(topSongData.previewUrl, topSongData.previewUrl, {
            album: topSongData.collectionName,
            // artist: topSongData.artistName,
            cover: topSongData.cover,
            itunes: topSongData.trackViewUrl,
            song: topSongData.trackName,
        });
    }

    function _handlingHover(type, data) {
        type === 'over'
            ? setHoverOnSong(data.previewUrl)
            : setHoverOnSong(false);

        return false;
    }

    function _mapTopSongs() {
        return listTopSongs.map((data) => {
            let isPlay = false;
            let isHover = false;

            // check if is song play
            isPlayTopSong !== data.previewUrl
                ? isPlay = false
                : isPlay = true;

            // check if is song hover
            hoverOnSong !== data.previewUrl
                ? isHover = false
                : isHover = true;

            // check if data name music exists
            if (data.trackName) {
                return (
                    <li key={data.trackName}>
                        <button
                            type="button"
                            className="topSongItem"
                            onMouseEnter={() => _handlingHover('over', data)}
                            onMouseLeave={() => _handlingHover('out', data)}
                            onClick={
                                !isPlay
                                    ? () => _handlingPlay(data)
                                    : () => _handlingPause(data)
                            }
                        >
                            <span className="player">
                                {!isPlay ?
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#252D38" />
                                        <path d="M16.8206 10.9083C17.6431 11.4002 17.6431 12.5996 16.8206 13.0915L10.4664 16.8915C9.62623 17.3939 8.5625 16.784 8.5625 15.7999L8.5625 8.19992C8.5625 7.21575 9.62623 6.60587 10.4664 7.10833L16.8206 10.9083Z" fill="#252D38" />
                                    </svg>
                                    :
                                    <FontAwesomeIcon icon={faPauseCircle} className={`${(isHover || isPlay) && 'opacity-8'}`} />}
                            </span>

                            <div className="infoSong">
                                {!isPlay && !isHover ?
                                    <h2>
                                        {data.trackName}
                                    </h2>
                                    :
                                    <div className="selectedTrack">
                                        <h2>
                                            {data.trackName}
                                        </h2>
                                    </div>}
                            </div>
                        </button>
                    </li>
                );
            }

            return null;
        });
    }

    useEffect(() => {
        if (artistSlug) {
            setTimeout(() => fetchArtistTopSongsIfNeeded(artistSlug, 3), 1000); // Fetch the TopSongs after a short timeout, to avoid bots fetching the artists (One second should be ok for 'normal' users)
        }
    }, [artistSlug, fetchArtistTopSongsIfNeeded]);

    if (!isFetching && listTopSongs?.length > 0) {
        return (
            <aside className="TopSongs">
                <div className="blockTitle">
                    <h1>
                        {/* Top 3 - {artistName} */}
                    </h1>
                </div>
                <ul>
                    {_mapTopSongs()}
                </ul>
            </aside>
        );
    }

    if (!isFetching && listTopSongs?.length === 0) {
        return null;
    }

    return <Placeholder minHeight="436px" margin="3rem 0 0 0" />;
};

TopSongs.propTypes = exact({
    // artistName: PropTypes.string, // this will be set only later, so it comes in as undefined sometimes
    artistSlug: PropTypes.string,
    fetchArtistTopSongsIfNeeded: PropTypes.func,
    listTopSongs: PropTypes.arrayOf(PropTypes.object),
    isFetching: PropTypes.bool,
    isPlayTopSong: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.bool.isRequired,
    ]),
    playTopSong: PropTypes.func,
    pauseTopSong: PropTypes.func,
});


export default TopSongs;
